let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4jkxA")).then(() => parcelRequire('9HpHb'));